import { memo, useCallback, useEffect, useState } from "react";
import { useTranslate } from "helpers";
import { OfferSaleCardProps } from "./types";
import { TextField } from "ui/components/TextField/TextField";
import { NumberField } from "ui/components/TextField/NumberField";
import { Button } from "ui/components/Button/Button";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import OfferSaleEditCard from "./components/OfferSaleEditCard/OfferSaleEditCard";
import { useDispatch, useSelector } from "react-redux";



import { Setting } from "services/api/settings/types";
import { getSettings } from "services/api/settings/redux/selectors";
import { initialSettingEditForm } from "services/api/settings";
import { fetchSettings } from "services/api/settings/redux";
import { TextArea } from "ui/components/TextField/TextArea";



const OfferSaleCard: React.FC<OfferSaleCardProps> = () => {

    const { t } = useTranslate();
    const dispatch = useDispatch();
    const settingCopy = useSelector(getSettings);
    const [setting, setSetting] = useState<Setting>(initialSettingEditForm);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);

    useEffect(() => {
        setSetting(settingCopy);
    }, [settingCopy]);

    const handleEditClick = () => {
        setShowEditModal(true);
    };

    const handleEditSuccess = useCallback(() => {
        dispatch(fetchSettings() as any);
        setShowEditModal(false);
    }, []);

    return (
        <>
            <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
                <div className="flex flex-col flex-1 max-w-[300px] ">
                    <div>
                        <p className="text-base font-bold text-slate-600 py-3">
                            1. {t("admin.setting.document.offer.sale.title")}
                        </p>
                        <p className="text-sm">
                            {t("admin.setting.document.offer.sale.description")}
                        </p>

                    </div>
                </div>
                <div className="flex justify-between items-center flex-1  px-3 my-3">
                    <div className="flex flex-col w-[400px]">
                        <div className="mb-3">
                            <TextField
                                type="text"
                                name="offerSaleFormatNumber"
                                label={t("admin.setting.document.offer.sale.offernumber")}
                                placeholder={t("admin.setting.document.offer.sale.offernumber")}
                                value={settingCopy.offerSaleFormatNumber}
                                disabled
                            ></TextField>
                        </div>

                        <div className="mb-3">
                            <ul className="common-list text-sm">
                                <li>{t("admin.setting.document.offer.sale.number.token.yyyy")}</li>
                                <li>{t("admin.setting.document.offer.sale.number.token.yy")}</li>
                                <li>{t("admin.setting.document.offer.sale.number.token.mm")}</li>
                                <li>{t("admin.setting.document.offer.sale.number.token.dd")}</li>
                                <li>{t("admin.setting.document.offer.sale.number.token.id")}</li>
                            </ul>
                        </div>
                        <div className="mb-3">
                            <NumberField
                                name="offerSaleDurationDays"
                                label={t("admin.setting.document.offer.sale.durationdays")}
                                value={settingCopy.offerSaleDurationDays}
                                decimals={0}
                                disabled
                            />
                        </div>
                        <div className="mb-3">
                            <TextArea
                                name="offerSaleNoteDefault"
                                label={t("admin.setting.document.offer.sale.notedefault")}
                                value={settingCopy.offerSaleNoteDefault}
                                required
                                endIcon=""
                                disabled
                            ></TextArea>
                        </div>
                    </div>
                    <div>
                        <Button
                            variant="outlined"
                            children={t("admin.edit")}
                            onClick={handleEditClick}
                            startIcon="/media/icons/plus.svg"
                        />
                    </div>
                </div>
            </div>

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <ModalHeader
                    title={t("admin.setting.document.offer.sale.edit.title")}
                    icon="/media/images/add-icon.svg"
                    onHide={() => setShowEditModal(false)}
                />
                <ModalBody>
                    {showEditModal && (
                        <OfferSaleEditCard
                            setting={setting}
                            setSetting={setSetting}
                            onSuccess={handleEditSuccess}
                            onClose={() => setShowEditModal(false)} />
                    )}
                </ModalBody>
            </Modal>

        </>
    );
};
export default memo(OfferSaleCard);
